import checkFF from '@/lib/feature-flag';
import { BusinessEntityStage } from '@apps-hr/types/business-entity';
import { BUSINESS_ENTITY_STAGES } from '@apps-hr/definitions.js';

export function isUnderMaintenance(): boolean {
  return checkFF('pwf-15-use-maintenance-window-for-employee-onboarding');
}

export function shouldEnableTrainingForDocumentTypeSettings(): boolean {
  return checkFF('pwf-3232-enable-training-tag-for-document-type-settings');
}

export function shouldEnableEmployeeOnboardingFlow(): boolean {
  return checkFF('nso-2-69-employee-onboarding-initiation');
}

export function shouldShowExportEmployees(): boolean {
  return checkFF('pwf-1574-enable-onboarding-csv-export');
}

export function shouldEnablePortalAndAdvisorAccess(): boolean {
  return checkFF('pwf-4140-enable-portal-and-advisor-access');
}

export function shouldEnableSignatureDocumentsDeletion(): boolean {
  return checkFF('pwf-4200-enable-signature-documents-delete');
}

export function shouldShowStartDateInInviteScreen(): boolean {
  return checkFF('pwf-4209-capture-employee-start-date-in-invite-screen');
}

export function shouldEnableCapturingBusinessNumberForUSOnboarding(): boolean {
  return checkFF('pwf-4237-enable-capturing-business-number-for-us-onboarding');
}

export function shouldEnableHrBeta(): boolean {
  return checkFF('hire-838-hr-beta');
}

export function shouldEnableHRApp(): boolean {
  return checkFF('pwf-3025-enable-hr-app');
}

export function shouldEnableDocManEmployeeExperience(): boolean {
  return shouldEnableHRApp();
}

export function shouldEnableHrPaywallLogic(): boolean {
  return checkFF('wo-981-deputy-hr-paywall');
}

export function shouldShowFreeOnboardingRemaining(): boolean {
  return checkFF('pwf-806-show-free-onboarding-remaining');
}

export function onboardingButtonABTest(): string {
  return checkFF<string>('pwf-2184-onboarding-button-a-b-testing');
}

export function shouldShowAddPeopleButtonForXeroEmbed(): boolean {
  return checkFF('eis-568-add-people-button-for-xero-embed');
}

export function shouldEnableKudos(): boolean {
  return checkFF('pwf-6186-enable-kudos');
}

export function shouldEnableSensitiveData(): boolean {
  return checkFF('pwf-5511-enable-hr-sensitive-data');
}

export function shouldSunsetRequestChangeAndResetOnboarding(): boolean {
  return checkFF('pwf-6134-sunset-request-change-and-reset-onboarding');
}

export function shouldEnableRTW(): boolean {
  return checkFF('pwf-6863-rtw-au');
}

export function getBusinessEntityStage(): BusinessEntityStage {
  return checkFF('pwf-7582-abn-business-entities-in-onboarding');
}

export function shouldShowBusinessEntityInOnboarding(): boolean {
  return [
    BUSINESS_ENTITY_STAGES.ABN_AND_DO_NOT_BLOCK_ONBOARDING,
    BUSINESS_ENTITY_STAGES.ABN_AND_BLOCK_ONBOARDING,
  ].includes(checkFF<string>('pwf-7582-abn-business-entities-in-onboarding'));
}

export function shouldRequireBusinessEntityInOnboarding(): boolean {
  return (
    checkFF<string>('pwf-7582-abn-business-entities-in-onboarding') ===
    BUSINESS_ENTITY_STAGES.ABN_AND_BLOCK_ONBOARDING
  );
}

export function shouldEnableSuperStapling(): boolean {
  return checkFF('pwf-8294-super-stapling');
}

export function shouldEnableTeamPerformancePage(): boolean {
  return checkFF('chip-1115-team-performance-page');
}
